import axios from "axios";

import { TTP_API_URL } from "../config";
import { getRequestConfig, throwCatchedError } from "../utils";

export const getUaSettings = ({ token, title, sort, page, start, limit }) => {
  const filter = [];

  if (title) {
    filter.push({ property: "title", value: title, operator: "like" });
  }

  const fields = ["*"];

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    start: page ? (page - 1) * limit : start,
    limit,
  };

  if (sort) {
    params.sort = JSON.stringify([sort]);
  }

  const requestUrl = `${TTP_API_URL}/organization/ua-settings`;

  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const getUaSettingByOrganisation = (token, organisationId) => {
  if (!token || !organisationId) {
    throw new Error("token and organisationId are required");
  }
  const requestUrl = `${TTP_API_URL}/organization/ua-settings/${organisationId}`;

  return axios.get(requestUrl, {
    headers: {
      Accept: "application/json,app=UA",
    },
    params: {
      access_token: token,
    },
  });
};

export const saveUaSettings = ({
  token,
  title,
  allowedApps,
  allowedTabs,
  id,
}) => {
  const requestUrl = `${TTP_API_URL}/organization/ua-settings`;

  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("title", title);
  formData.append("allowedApps", allowedApps);
  formData.append("allowedTabs", allowedTabs);

  if (id) {
    formData.append("id", id);
  }
  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};

export const getHotels = ({ token, sort }) => {
  const fields = ["*"];

  let params = {
    access_token: token,
    fields: fields.join(","),
  };

  if (sort) {
    params.sort = JSON.stringify([sort]);
  }

  const requestUrl = `${TTP_API_URL}/organization/hotel`;

  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const getMembersByHotel = ({
  token,
  hotel,
  distance,
  limit,
  nolimit = false,
  showMoreLimit,
  years,
  notMembersYears = [],
}) => {
  const fields = ["*", "group"];

  let params = {
    access_token: token,
    fields: fields.join(","),
    hotel,
    distance,
    limit,
    years,
  };

  if (nolimit) {
    params.nolimit = 1;
  }

  if (notMembersYears.length > 0) {
    params.notMembersYears = notMembersYears;
  }

  if (showMoreLimit) {
    params.showMoreLimit = 1;
  }

  const requestUrl = `${TTP_API_URL}/organization/ua-membership/members-by-hotel`;

  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const saveHotel = ({
  token,
  name,
  address,
  zipcode,
  city,
  latitude,
  longitude,
}) => {
  const requestUrl = `${TTP_API_URL}/organization/hotel`;

  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("name", name);
  formData.append("address", address);
  formData.append("zipCode", zipcode);
  formData.append("city", city);
  formData.append("country", "BE");
  formData.append("latitude", latitude);
  formData.append("longitude", longitude);

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};
